import React, { Fragment, useState } from 'react'
import SalesReportListView from '../../../components/inventory/reports/product_sale_rpt/SalesReportListView'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const InventorySalesReportListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/transaction/sales/report/list/');
    const { data, loading, error, refetch } = useFetchData(onURL);
  
    const handleFormSuccess = (): void => {
        refetch();
    };
  return (
    <Fragment>
        <SalesReportListView loading={loading} setOnURL={setOnURL} error={error} handleFormSuccess={handleFormSuccess} data={data} />
    </Fragment>
  )
}

export default InventorySalesReportListView